import { createContext, useContext } from 'react';
export interface GoogleAnalyticValues {
    onCategoryClick: (params: {
        categoryId: string;
        categoryName: string;
        categoryLevel: number;
        navLocation?: string;
    }) => void;
}

export const GoogleAnalyticContext = createContext<GoogleAnalyticValues>({
    onCategoryClick: () => {},
});

export const useGoogleAnalyticsContext = () =>
    useContext(GoogleAnalyticContext);
